import { Observable, of } from 'rxjs';
import { isAuthenticated } from './auth0-pcke';
import { logEvent } from './log-event';
import { Inject } from '@nestjs/common';

const opn = require('opn');

interface Doc {
  id: string;
  description: string;
  prop?: string;
}

// TODO: vsavkin get the information from the API
export class ConnectDocsProvider {
  constructor(@Inject('telemetry') private readonly telemetry: any) {}

  workspaceDocs(dependencies: {
    [depName: string]: string;
  }): Observable<Doc[]> {
    if (!isAuthenticated) {
      return of([]);
    }

    if (dependencies['@nrwl/schematics'] || dependencies['@nrwl/nx']) {
      return of([
        {
          id: 'nrwl:https://nrwl.io/nx/guide-nx-workspace',
          description:
            'Nrwl Connect: Learn about Nx workspaces and how to use them.'
        }
      ]);
    } else {
      return of([]);
    }
  }

  schematicDocs(
    collectionName: string,
    collectionVersion: string,
    name: string
  ): Observable<Doc[]> {
    if (!isAuthenticated) {
      return of([]);
    }

    if (collectionName === '@nrwl/schematics') {
      if (name === 'application ') {
        return of([
          {
            id: 'nrwl:https://nrwl.io/nx/guide-nx-workspace',
            description:
              'Nrwl Connect: Learn about applications and how to create them in an Nx Workspace.'
          }
        ]);
      } else if (name === 'library') {
        return of([
          {
            id: 'nrwl:https://nrwl.io/nx/guide-nx-workspace',
            description:
              'Nrwl Connect: Learn about libraries and how to create them in an Nx Workspace.'
          }
        ]);
      } else if (name === 'ngrx') {
        return of([
          {
            id: 'nrwl:https://nrwl.io/nx/guide-setting-up-ngrx',
            description:
              'Nrwl Connect: Learn about managing state using NgRx in Nx.'
          }
        ]);
      } else if (name === 'workspace-schematic') {
        return of([
          {
            id: 'nrwl:https://nrwl.io/nx/workspace-specific-schematics',
            description:
              'Nrwl Connect: Learn about promoting best practices using Nx and workspace schematics.'
          }
        ]);
      }
    }

    return of([]);
  }

  openDoc(id: string) {
    if (id.startsWith('nrwl:')) {
      logEvent(this.telemetry, 'OpenDoc');
      const url = id.substr(5);
      opn(url);
      return of(true);
    } else {
      return of(false);
    }
  }
}
